// libraries
import styled from 'styled-components';

export const StyledDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 28px 28px;
  font-family: inherit;
  white-space: normal;

  .detail-preview {
    width: 100%;
    max-height: 220px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid var(--color-border-light-gray);
    background: var(--color-off-white);
  }

  .detail-viewer {
    width: 100%;
    height: 320px;
    border-radius: 8px;
    overflow: hidden;
  }

  .detail-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    border-bottom: 1px solid var(--color-border-light-gray);
    font-size: 14px;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    .detail-label {
      min-width: 70px;
      color: var(--color-text-gray);
      font-weight: 500;
    }
  }
`;
